var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailContrast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-24-/-Outline-/-Social-/-mail_",
    transform: "translate(-2.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.9999926e-8,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00000005,4 L22,4 L22,18 C22,19.1045695 21.1045695,20 20,20 L4.00000005,20 C2.89543055,20 2.00000005,19.1045695 2.00000005,18 L2.00000005,4 Z M20,7.45 L14.14,13.45 L14.14,13.5 C12.9549811,14.6561169 11.0574263,14.6337401 9.90000005,13.45 L4.00000005,7.45 L4.00000005,17 C4.00000005,17.5522847 4.4477153,18 5.00000005,18 L19,18 C19.5522848,18 20,17.5522847 20,17 L20,7.45 Z M5.38000005,6 L11.29,12 C11.6800375,12.3877236 12.3099626,12.3877236 12.7,12 C12.7,12 14.7,10 18.62,5.95 L5.38000005,6 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fillOpacity: 0.8,
    fill: "#38e5e2",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailContrast);
export default __webpack_public_path__ + "static/media/mail-contrast.a25b77e8f1f88897fa79e2a03d39c8cb.svg";
export { ForwardRef as ReactComponent };